module.exports = __webpack_public_path__ + "610c5d29d1f1970a.svg";